// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gDLFX","no-stories":"_4myX5"};